import Header from "./components/Header/Header"
import Hero from "./components/Hero/Hero"
import TrustBar from "./components/TrustBar/TrustBar"
import AboutSection from "./components/AboutSection/AboutSection"
import CategoriesSection from "./components/CategoriesSection/CategoriesSection"
import CatalogSection from "./components/CatalogSection/CatalogSection"
import ShippingSection from "./components/ShippingSection/ShippingSection"
import ProcessSection from "./components/ProcessSection/ProcessSection"
import FAQSection from "./components/FAQSection/FAQSection"
import FinalCTA from "./components/FinalCTA/FinalCTA"
import Footer from "./components/Footer/Footer"
import GallerySection from "./components/GallerySection/GallerySection"
import CasosExito from "./components/CasosExito/CasosExito"

function App() {
  return (
    <>
      <Header />
      <Hero /><br/><br/>
      <TrustBar />
      <AboutSection />
      <CategoriesSection />
      <CatalogSection />
      <ShippingSection />
      <ProcessSection />
      <GallerySection />
      <CasosExito />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </>
  )
}

export default App